import {
  MealEntity,
} from './mealEntity';
import { MealContent } from './valueObjects/mealContent';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';

import type {
  MealPropsPub,
  MealPropsPvt,
} from './mealEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { MealJsonPub, MealJsonPvt } from '@/types/domain/meal/entities/mealEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class MealFactory extends FactoryPub<
  MealEntity,
  MealPropsPvt,
  MealJsonPvt,
  MealPropsPub,
  MealJsonPub
> {
  comparePub = (
    a: EntityDataPubType<MealJsonPvt, MealJsonPub>,
    b: EntityDataPubType<MealJsonPvt, MealJsonPub>,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: MealPropsPvt,
    propsPub: EntityPubNotNullType<MealPropsPub>,
  ): MealEntity {
    return new MealEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<MealJsonPvt, MealJsonPub>,
  ): MealEntity {
    return this.create({
      measureDateTime: MeasureDateTime.create(new Date(props.data.measureDateTime)),
      measurerId: MeasurerId.create(props.data.measurerId),
      measurerType: MeasurerType.create(props.data.measurerType),
      parentId: ParentId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
      mealContent: MealContent.create(props.data.mealContent),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
